import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { createShouldForwardProp } from '../../helpers/createShouldForwardProp';
import { unit } from '../../styles';
import { compose, createPropTypes, layout, margin } from '../../styles/system';
import { jsx as _jsx } from "react/jsx-runtime";
const SIZES = {
  xxlarge: unit(20),
  xlarge: unit(15),
  large: unit(8),
  medium: unit(6),
  small: unit(6),
  xsmall: unit(4),
  xxsmall: unit(4)
};
const GLYPH_SIZES = {
  xxlarge: unit(18),
  xlarge: unit(12),
  large: unit(7),
  medium: unit(5),
  small: unit(4),
  xsmall: '14px',
  xxsmall: unit(3)
};
const styleProps = compose(margin, layout).withDefaults({
  display: 'inline-flex',
  verticalAlign: '-0.125em;'
});
const shouldForwardProp = createShouldForwardProp(styleProps.propNames);
const IconWrapper = /*#__PURE__*/styled.span.withConfig({
  shouldForwardProp
}).withConfig({
  displayName: "IconWrapper",
  componentId: "ig660u-0"
})(["", " align-items:center;justify-content:center;color:", ";fill:", ";flex-shrink:0;> svg{width:", ";height:", ";overflow:hidden;pointer-events:none;}"], styleProps, props => props.primaryColor || 'currentColor', props => props.secondaryColor || 'currentColor', props => props.glyphSize || 'inherit', props => props.glyphSize || 'inherit');

function getSize(value) {
  if (typeof value === 'number') {
    return unit(value);
  }

  if (Object.prototype.hasOwnProperty.call(SIZES, value)) {
    return SIZES[value];
  }

  return value;
}

const Icon = /*#__PURE__*/forwardRef(function Icon(_ref, forwardedRef) {
  let {
    glyph: Glyph,
    size: propSize = 'small',
    primaryColor,
    secondaryColor,
    children
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["glyph", "size", "primaryColor", "secondaryColor", "children"]);

  const size = getSize(propSize);
  return /*#__PURE__*/_jsx(IconWrapper, Object.assign({
    ref: forwardedRef,
    size: size,
    glyphSize: GLYPH_SIZES[propSize],
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  }, restProps, {
    children: Glyph ? /*#__PURE__*/_jsx(Glyph, {}) : children
  }));
});
Icon.propTypes = Object.assign({
  glyph: T.elementType,
  primaryColor: T.string,
  secondaryColor: T.string,
  children: T.node
}, createPropTypes(margin.propNames), createPropTypes(layout.propNames), {
  size: T.oneOfType([T.number, T.string, T.oneOf(Object.keys(SIZES))])
});
export { Icon };